import React, { Component } from 'react';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import { Button, Input, Select } from 'antd';
import fp from '../../../utils/fp';

const Option = Select.Option;

class Filter extends Component {
    state = {
        areaList: [],
        diseaseList: [],
        businessList: [],
    }

    componentDidMount() {
        this.loadAreaList();
        this.queryWithLevelByParams();
    }

    search = () => {
        this.props.search();
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.queryAllInvestigationArea}`,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, data => {
            this.setState({ areaList: data.data });
        });
    }

    loadDiseaseList = investigationAreaId => {
        if (investigationAreaId) {
            dictCache.getDict(`DISEASE_AREA_${investigationAreaId}`, cb => {
                $.sendRequest({
                    method: 'POST',
                    url: `${API_URL.common.queryAllDisease}`,
                    data: {
                        investigationAreaId,
                    },
                    dataType: 'json',
                    doneResult: res => cb(res),
                });
            }, data => {
                this.setState({ diseaseList: data.data });
            });
        } else {
            this.setState({ diseaseList: [] });
        }
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'investigationAreaId':
                searchParams[key] = value;
                searchParams.diseaseId = undefined;
                onChange(searchParams);
                this.loadDiseaseList(value);
                break;
            case 'lineOfBusiness':
                searchParams[key] = value;
                searchParams.secondLineName = undefined;
                onChange(searchParams);
                break;
            default:
                searchParams[key] = value;
                onChange(searchParams);
        }
    }

    render() {
        const {
            areaList,
            diseaseList,
            businessList,
        } = this.state;
        const { isAdd, searchParams, crcFlag } = this.props;
        const {
            hospitalName,
            departmentName,
            userCompellation,
            userMobile,
            investigationAreaId,
            diseaseId,
            investigationName,
            piIdentity,
            leadgingPiFlag,
            isCooperation,
            lineOfBusiness,
            cityManagerFilter,
        } = searchParams;
        const { curRole } = sessionStorage;
        const showExportButton = curRole !== 'CRC';
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const areaListOption = areaList.map(d => <Option key={d.investigationAreaId}>{d.investigationAreaName}</Option>);
        const diseaseListOption = diseaseList.map(d => <Option key={d.diseaseId} value={d.diseaseId}>{d.diseaseName}</Option>);
        return (
            <div className="filter-bar">
                <div className="filter-bar-investigation">
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">医院官方名称</label>
                        <Input
                            placeholder="请输入"
                            value={hospitalName}
                            onChange={e => this.handleChange(e.target.value, 'hospitalName')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">科室</label>
                        <Input
                            placeholder="请输入"
                            value={departmentName}
                            onChange={e => this.handleChange(e.target.value, 'departmentName')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">医生姓名</label>
                        <Input
                            placeholder="请输入"
                            value={userCompellation}
                            onChange={e => this.handleChange(e.target.value, 'userCompellation')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">手机号码</label>
                        <Input
                            placeholder="请输入"
                            value={userMobile}
                            onChange={e => this.handleChange(e.target.value, 'userMobile')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    {!crcFlag && <div className="form-item">
                        <label htmlFor="" className="ui-label">项目领域</label>
                        <Select
                            allowClear={true}
                            style={{ width: 120 }}
                            onChange={value => this.handleChange(value, 'investigationAreaId')}
                            value={investigationAreaId}
                            placeholder="请选择"
                        >
                            {areaListOption}
                        </Select>
                    </div>}
                    {!crcFlag && <div className="form-item">
                        <label htmlFor="" className="ui-label">疾病</label>
                        <Select
                            allowClear={true}
                            style={{ width: 150 }}
                            onChange={value => this.handleChange(value, 'diseaseId')}
                            disabled={!investigationAreaId}
                            value={diseaseId}
                            placeholder="请选择"
                        >
                            {diseaseListOption}
                        </Select>
                    </div>}
                    {!crcFlag && <div className="form-item">
                        <label htmlFor="" className="ui-label">项目简称</label>
                        <Input
                            placeholder="请输入"
                            value={investigationName}
                            onChange={e => this.handleChange(e.target.value, 'investigationName')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>}
                    {!crcFlag && <div className="form-item">
                        <label htmlFor="" className="ui-label">临床项目身份</label>
                        <Select
                            allowClear={true}
                            style={{ width: 150 }}
                            onChange={value => this.handleChange(value, 'piIdentity')}
                            value={piIdentity}
                            placeholder="请选择"
                        >
                            <Option value='PI'>PI</Option>
                            <Option value='SUB_1'>Sub-I</Option>
                            <Option value='Research_nurse'>研究护士</Option>
                            <Option value='Others'>其他(药师、技师等)</Option>
                        </Select>
                    </div>}
                    {!crcFlag && <div className="form-item">
                        <label htmlFor="" className="ui-label">是否为leading PI</label>
                        <Select
                            allowClear={true}
                            style={{ width: 150 }}
                            onChange={value => this.handleChange(value, 'leadgingPiFlag')}
                            value={leadgingPiFlag}
                            placeholder="请选择"
                        >
                            <Option value='true'>是</Option>
                            <Option value='false'>否</Option>
                        </Select>
                    </div>}
                    {
                        fp.contains(curRole, ['CRCM', 'CRCC']) &&
                        <div className="form-item">
                            <label className="ui-label">是否为自己区域内的医院</label>
                            <Select
                                allowClear={true}
                                style={{ width: 80 }}
                                onChange={(value) => this.handleChange(value, 'cityManagerFilter')}
                                value={cityManagerFilter}
                                placeholder="请选择"
                            >
                                <Option value="1">是</Option>
                                <Option value="0">否</Option>
                            </Select>
                        </div>
                    }
                    <div className="form-item">
                        <label className="ui-label">是否为自己负责的医院</label>
                        <Select
                            allowClear={true}
                            style={{ width: 80 }}
                            onChange={(value) => this.handleChange(value, 'isMyResponsibleHospital')}
                            placeholder="请选择"
                        >
                            <Option value="1">是</Option>
                            <Option value="0">否</Option>
                        </Select>
                    </div>
                    {!crcFlag && <div className="form-item">
                        <label htmlFor="" className="ui-label">在岗状态</label>
                        <Select
                            onChange={value => this.handleChange(value, 'postStatus')}
                            placeholder="请选择"
                            style={{ width: 90 }}
                            allowClear={true}
                        >
                            <Option value="ON">在岗</Option>
                            <Option value="OFF">转岗</Option>
                            <Option value="RETIRED">退休</Option>
                            <Option value="LEFT">离职</Option>
                            <Option value="DECEASED">离世</Option>
                        </Select>
                    </div>}
                    {!crcFlag && <div className="form-item">
                        <label className="ui-label">与津石是否有合作</label>
                        <Select
                            allowClear={true}
                            style={{ width: 80 }}
                            onChange={(value) => this.handleChange(value, 'isCooperation')}
                            value={isCooperation}
                            placeholder="请选择"
                        >
                            <Option value="1">是</Option>
                            <Option value="0">否</Option>
                        </Select>
                    </div>}
                    {!crcFlag && <div className="form-item">
                        <label htmlFor="" className="ui-label">业务线</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={lineOfBusiness}
                            onChange={value => this.handleChange(value, 'lineOfBusiness')}
                        >
                            {businessOption}
                        </Select>
                    </div>}
                    {!crcFlag && <div className="form-item">
                        <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            disabled={!lineOfBusiness}
                            value={searchParams.secondLineName}
                            onChange={value => this.handleChange(value, 'secondLineName')}
                        >
                            {secondLineOption}
                        </Select>
                    </div>}
                    <div className="form-item">
                        {isAdd && <Button type="primary" onClick={() => this.props.update(true)}>添加</Button>}
                        {
                            showExportButton &&
                            <Button type="primary" onClick={this.export}>导出</Button>
                        }
                        <Button type="primary" onClick={this.search}>搜索</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/hospital/doctorInfo/Filter.js